<template>
  <!-- 物流系统 比价订舱服务商界面 -->
  <div>
    <el-form :model="bookInfoForm" ref="ruleForm" :rules="rules" label-width="140px" class="el_form" label-position="top"
      v-loading="loading" element-loading-text="加载中···" >
      <el-form-item label="类别" size="small">
        <el-input v-model="bookInfoForm.type" readonly disabled placeholder="-"></el-input>
      </el-form-item>
      <el-form-item label="国家/目的港" size="small">
        <el-input v-model="bookInfoForm.destinationPort" readonly disabled placeholder="-"></el-input>
      </el-form-item>
      <el-form-item label="起运港" size="small">
        <el-input v-model="bookInfoForm.shipmentPort" readonly disabled placeholder="-"></el-input>
      </el-form-item>
      <el-form-item label="服务范围" size="small">
        <el-input v-model="bookInfoForm.serviceArea" readonly disabled placeholder="-"></el-input>
      </el-form-item>
      <el-form-item label="报价截止时间" size="small">
        <el-input v-model="bookInfoForm.endDate" readonly disabled placeholder="-"></el-input>
      </el-form-item>
      <el-form-item label="报价次数" size="small">
        <el-input v-model="bookInfoForm.quotationTimes" readonly disabled placeholder="-"></el-input>
      </el-form-item>
      <el-form-item label="表单状态" size="small">
        <el-input v-model="bookInfoForm.formStatus" readonly disabled placeholder="-"></el-input>
      </el-form-item>
      <el-form-item label="订舱信息" >
        <el-table
          :data="bookInfoForm.bookSpaceInfos"
          border
          style="width: 100%"
          :span-method="contactNoSpanMethod"
        >
          <el-table-column prop="contactNo" label="订舱合同号"></el-table-column>
          <el-table-column prop="spaceDate" label="预装柜日期" width="100"></el-table-column>
          <el-table-column prop="containerType" label="柜型" align="center"></el-table-column>
          <el-table-column prop="containerCount" label="柜量" width="60" align="center"></el-table-column>
          <!--<el-table-column prop="currency" label="币种" width="60" align="center"></el-table-column>-->
          <el-table-column prop="currency" label="币种" width="60" align="center">
            <template slot-scope="scope">
              <span style="color: red; font-weight: bold;">{{ scope.row.currency }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="targetPrice" label="目标价" width="80" align="center"></el-table-column>
          <el-table-column prop="remark" label="特殊要求"></el-table-column>
        </el-table>
      </el-form-item>

      <el-form-item label="当前排名" >
        <el-input v-model="bookInfoForm.rank" readonly disabled placeholder="暂无排名"></el-input>
      </el-form-item>
      <!-- <el-form-item label="价格" prop="price" :rules="{ required: true, message: '请输入价格'}">
        <el-input v-model="bookInfoForm.price" type="number" placeholder="请输入数字"></el-input>
      </el-form-item> -->
      <div v-for="item in bookInfoForm.bookSpaceInfos" :key="item.id">
        <el-form-item :label="`${item.containerType}价格`" :rules="{ required: true, message: '请输入价格'}">
          <el-input v-model="priceArr[item.containerType]" type="number" placeholder="请输入数字"></el-input>
        </el-form-item>
      </div>

      <el-form-item label="物流公司备注" prop="memo" >
        <el-input v-model="bookInfoForm.memo" type="textarea" placeholder="请输入"></el-input>
      </el-form-item>

      <!-- 报价历史 -->
      <el-form-item label="历史报价记录">
        <el-table
          :data="historyTableData"
          border
          style="width: 100%"
          class="historyTableStyle"
        >
          <el-table-column type="index" width="60" align="center"></el-table-column>
          <el-table-column prop="offerPrice" label="价格" align="center"></el-table-column>
          <el-table-column prop="createTime" label="提交时间" align="center"></el-table-column>
          <el-table-column label="操作" width="120" align="center">
            <template slot-scope="scope">
              <el-button
                size="mini"
                type="danger"
                @click="handleDelete(scope.$index, scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-form-item>
    </el-form>

    <div class="footer">
      <el-button round class="footer-btn" type="primary" @click="onSubmit" :disabled="issubmitDisabled">提交</el-button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      bookInfoForm: {},
      rules: {},
      historyTableData: [],
      url: {
        queryFormFormId: '/bookspaceinquiry/queryFormFormId',   //查询本单详情，get，传formid和type
        saveForm: '/bookspaceinquiry/saveForm',   //提交报价单，post，传表单信息
        queryHistoryForm: '/bookspaceinquiry/queryHistoryForm',   //查看报价历史，get
        deleQuotation: '/bookspaceinquiry/deleQuotation',   //删除报价，get，传参formid，createTime
      },
      issubmitDisabled: false,
      loading: true,
      priceArr: []
    }
  },
  created() {
    this.$get(this.url.queryFormFormId, this.$route.query).then(res => {
      if(res.code === 200) {
        this.bookInfoForm = res.result
        this.queryHistoryForm_API()
      } else {
        this.$message.error(res.message)
      }
      this.loading = false
    })
  },
  // 组件内的路由守卫
  beforeRouteLeave(to, from, next) {
    localStorage.removeItem('X-Access-Token')
    next()
  },
  methods: {
    onSubmit() {
      const price = Object.entries(this.priceArr).map(([key, value]) => ({ key, value }));
      this.bookInfoForm.price = price
      let isRequired = Object.values(this.priceArr).length == this.bookInfoForm.bookSpaceInfos.length
      this.$refs.ruleForm.validate((valid) => {
        if (valid && isRequired) {
          // console.log('填写的表单内容: ', this.bookInfoForm)
          this.$post(this.url.saveForm, this.bookInfoForm).then(res => {
            if(res.code === 200) {
              this.$message.success('提交成功, 排名更新')
              this.issubmitDisabled = true
              this.$nextTick(() => {
                this.bookInfoForm.rank = res.result.rank
              })
              // setTimeout(() => {
              //     window.close()
              // }, 1100)
            } else {
              this.$message.error(res.message)
            }
          })
        } else {
          this.$message.warning('有必填项未填写，请填写后再提交！')
          return false;
        }
      });
    },
    // 订舱合同号 行合并
    contactNoSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        if (rowIndex === 0) {
          return {
            rowspan: this.bookInfoForm?.bookSpaceInfos?.length,
            colspan: 1
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
    },
     // 删除报价记录
    handleDelete(index, row) {
      // console.log('handleDelete->', index, row)
      this.deleQuotation_API(row.inquiryFromId, row.createTime)
    },
    queryHistoryForm_API() {
      this.$get(this.url.queryHistoryForm, { inquiryFromId: this.bookInfoForm.inquiryFromId }).then(res => {
        this.historyTableData = res
      })
    },
    deleQuotation_API(formid, createTime) {
      this.$get(this.url.deleQuotation, { formid: formid, createTime: createTime}).then(res => {
        if(res.code === 200) {
          this.$message.success('删除成功')
          this.$nextTick(() => {
            this.queryHistoryForm_API()
          })
        } else {
          this.$message.error(res.message)
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.el_form {
  padding: 10px 10px 70px;
  /deep/ .el-form-item__label {
    padding: 0;
  }
  /deep/ .el-table__cell {
    padding: 4px;
  }
  /deep/ .el-form-item {
    margin-bottom: 10px;
  }
  /deep/ .el-table thead {
    color: rgba(0, 0, 0, .7);
  }
}

.footer {
  width: 100%;
  height: 60px;
  line-height: 60px;
  min-width: 375px;
  max-width: 740px;
  margin: 0 auto;
  background: #fff;
  border-top: 1px solid #eee;
  position: fixed;
  bottom: 0;
  text-align: center;
  z-index: 10;
  .footer-btn {
    // width: 48%;
    width: 98%;
  }
}
.historyTableBox {
  margin: 0 16px;
  .historyTableStyle {
    color: #000;
    font-size: 12px;
    td {
      color: #000;
      padding: 4px 0;
    }
  }
}
</style>